export function Money(value) {
  return Math.round(parseFloat(value) * 100) / 100;
}
